import { XIcon } from "lucide-react";
import { useFieldArray, useFormContext } from "react-hook-form";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";

import { AddSessionFormData } from "../types/add-session-schema";

export function OrganisationsListElement() {
  const form = useFormContext<AddSessionFormData>();
  const organisations = useFieldArray({
    control: form.control,
    name: "invitedOrganisations",
  });

  if (organisations.fields.length === 0) {
    return null;
  }

  return (
    <ScrollArea
      type="always"
      className={cn("rounded-md border border-border", {
        "h-[427px]": organisations.fields.length > 7, // 7 items * 61px = 427px
      })}
    >
      <div className="divide-y divide-border">
        {organisations.fields.map((organisation, index) => (
          <div
            key={organisation.id}
            className="flex items-center justify-between px-4 py-2"
          >
            <div className="flex min-w-0 items-center">
              <div className="ml-2 min-w-0">
                <p className="truncate text-sm font-medium text-foreground">
                  {organisation.name}
                </p>
                {organisation.status === "ACCEPTED" && (
                  <Badge variant="outline">
                    <span className="flex items-center">
                      <span className="mr-2 inline-block size-2 rounded-full bg-green-500" />
                      Accepted
                    </span>
                  </Badge>
                )}
                {organisation.status === "PENDING" && (
                  <Badge variant="outline">
                    <span className="flex items-center">
                      <span className="mr-2 inline-block size-2 rounded-full bg-warning" />
                      Pending
                    </span>
                  </Badge>
                )}
                {organisation.status === "REJECTED" && (
                  <Badge variant="outline">
                    <span className="flex items-center">
                      <span className="mr-2 inline-block size-2 rounded-full bg-red-500" />
                      Rejected
                    </span>
                  </Badge>
                )}
                {organisation.status === "HOST" && (
                  <Badge variant="outline">Host </Badge>
                )}
              </div>
            </div>
            {organisation.status === "NEW" && (
              <Button
                variant="ghost"
                size="icon"
                onClick={() => organisations.remove(index)}
                type="button"
              >
                <XIcon className="size-4" />
              </Button>
            )}
          </div>
        ))}
      </div>
    </ScrollArea>
  );
}
